module.exports = __webpack_public_path__ + "static/img/scene-fydy.f91c47f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scene/scene-fydy.png
// module id = 6qdZ
// module chunks = 1